var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gs-divider",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"divider",style:({ height: _vm.stroke, background: _vm.color, margin: `0 ${_vm.margin}` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }